// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__80kz5","left":"styles_left__3vSVx"};